import TYPE from "../../constants/type";
import { apiCall } from "../../utils/api";
import { notification } from "../home/action";
import { API_URLS } from "../../constants/api";
import { PREFIX } from "../../constants/enums";

export const getAuditLogByModel = (modelType, modelId) => async (dispatch) => {
  const api = API_URLS.AUDIT_LOG.getAuditLogByModel(modelType, modelId);
  dispatch({
    type: TYPE.AUDIT_LOG.GET_AUDIT_LOG_BY_MODEL_LOADING,
    meta: { prefix: [PREFIX.AUDIT_LOG, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.AUDIT_LOG.GET_AUDIT_LOG_BY_MODEL_SUCCESS,
      payload: response.data.data?.list || [],
      meta: { prefix: [PREFIX.AUDIT_LOG, PREFIX.API_SUCCESS] },
    });
  } else {
    dispatch({
      type: TYPE.AUDIT_LOG.GET_AUDIT_LOG_BY_MODEL_FAILURE,
      meta: { prefix: [PREFIX.AUDIT_LOG, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Lấy lịch sử chỉnh sửa thất bại!",
      }),
    );
  }
};

export const filterAuditLog = (page, pageSize, payload) => async (dispatch) => {
  const api = API_URLS.AUDIT_LOG.filterAuditLog(page, pageSize);
  dispatch({
    type: TYPE.AUDIT_LOG.FILTER_AUDIT_LOG_LOADING,
    meta: { prefix: [PREFIX.AUDIT_LOG, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.AUDIT_LOG.FILTER_AUDIT_LOG_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.AUDIT_LOG, PREFIX.API_SUCCESS] },
    });
  } else {
    dispatch({
      type: TYPE.AUDIT_LOG.FILTER_AUDIT_LOG_FAILURE,
      meta: { prefix: [PREFIX.AUDIT_LOG, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Lọc lịch sử chỉnh sửa thất bại!",
      }),
    );
  }
};

